import { COLORS, FONT_FAMILY } from "../shared/shared.constants";

export const customerSurveyConstants = {
  DEFAULT_STAR_COLOR: COLORS.GOLD,
  DEFAULT_MAIN_THEME_COLOR: COLORS.DARK_TEAL,
  DEFAULT_PREVIEW_MAIN_THEME_COLOR: COLORS.AMBER,
  DEFAULT_FONT_COLOR: COLORS.BLACK,
  DEFAULT_FONT_FAMILY: FONT_FAMILY.ARIAL,
  DEFAULT_PROGRESS_BAR_COLOR: COLORS.DARK_TEAL,
  SURVEY_LOGO_WIDTH_PX: 100,
  STAR_ICON_SIZE: 50,
  CHECK_ICON_SIZE: 30,
  GOOGLE_ICON_SIZE: 26,
  ANGLE_ICON_SIZE: 16,
  TEXTAREA_ROWS: 10,
  TRUE_VALUE: "true",
  DEFAULT_QUESTION_PAGE: 0,
  FIRST_QUESTION_ORDER: 1,
  ZERO_ORDER_ID: 0,
  ZERO_RATING: 0,
  FULL_PROGRESS: 100,
  MIN_QUESTIONS_TO_RENDER: 1,
  CSS_MAIN_THEME: "--main-theme",
  CSS_FONT_COL: "--font-col",
  CSS_FONT_FAMILY: "--font-family",
  CSS_BAR_COL: "--bar-col",
  CSS_STAR_THEME: "--star-theme",
};

export const customerSurveyLabels = {
  CUSTOMER_NAME: "Customer Name: ",
  EMAIL: "Email: ",
  ORDER_ID: "Order Id: ",
  SURVEY_SUBMITTED: "Survey Submitted!",
  SURVEY_SUBMITTED_SHORT: "Survey Submitted",
  SURVEY_ALREADY_SUBMITTED: "Survey has already been Submitted!",
  SURVEY_LINK_EXPIRED: "Survey Link has Expired!",
  NO_SURVEY_EXIST: "No survey exist!",
  RATING_REQUIRED: "rating required",
  OPTIONAL: "(Optional)",
  ADD_COMMENTS_PLACEHOLDER: "Add Comments Here",
  UNSUPPORTED_QUESTION_TYPE: "Unsupported question type",
  ENJOYED_EXPERIENCE_STRONG: "Enjoyed your experience?",
  GOOGLE_REVIEW_HELP: "A quick Google review helps us a lot.",
  WANT_TO_HELP: "Want to help us out?",
  LEAVE_GOOGLE_REVIEW: "Leave us a Google Review",
  TAKES_LESS_THAN_30: "Takes less than 30 seconds",
  AUTO_COPIED_BOLD: "Auto‑copied",
  PASTE_BOLD: "Paste",
  AUTO_COPIED_COMMENT_PREFIX: "We’ve",
  AUTO_COPIED_COMMENT_MIDDLE:
    "your comment for you! Just click the Google Review button above and",
  AUTO_COPIED_COMMENT_SUFFIX: "it into the box.",
  MISSED_COPY_HINT: "Missed it? Tap below to copy again.",
  COMMENT_COPIED_CONFIRMATION:
    "No need to worry, we've got your comment copied!",
  LOGO_ALT: "logo",
  STAR_RANKING_ARIA: "star-ranking-question",
  CUSTOMER_NAME_ARIA: "customer-name",
  CUSTOMER_EMAIL_ARIA: "customer-email",
  CUSTOMER_ORDER_ID_ARIA: "customer-order-id",
  QUESTION_TEXT_ARIA: "question-text",
  RATING_REQUIRED_ARIA: "rating-required-error",
  PRIMARY_TEXTBOX_ARIA: "primary-textbox",
  getCharLimitExceededMessage: (limit) =>
    `characters must not exceed ${limit} characters`,
};
